export default function FollowUpsMock() {
  return (
    <img
      src="/images/landing-v2/features/followups.svg"
      alt="Shadow drafting recap, next steps, and a calendar invite right after a call"
      className="w-full select-none"
      draggable="false"
    />
  );
}
